import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ParticipantsSelector } from 'modules/engagement_surveys/components/ParticipantsSelector'
import type { WizardStepProps } from 'modules/engagement_surveys/components/SurveyWizard/types'

export function ParticipantsStep({ data, onDataChanged }: WizardStepProps) {
  return (
    <Box gap="s32" gapDivider>
      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.participants.title')}
        </Text.Header2>

        <ParticipantsSelector
          value={data.respondentStrategy}
          onChange={(respondentStrategy) => {
            onDataChanged({
              ...data,
              respondentStrategy,
            })
          }}
          onEmployeeSelectionChange={(selection) => {
            onDataChanged({
              ...data,
              respondentEmployeeSelection: selection,
            })
          }}
        />
      </Box>

      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.privacy_settings.title')}
        </Text.Header2>

        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                onChange={(value) => {
                  onDataChanged({ ...data, anonymous: value })
                }}
                value={data.anonymous}
              />
            }
          >
            {i18n.t('surveys.configuration.privacy_settings.anonymous_answers')}
          </Card.Title>
          <Card.Description>
            {i18n.t('surveys.configuration.privacy_settings.anonymous_answers_description')}
          </Card.Description>
        </Card>
      </Box>
    </Box>
  )
}
